module.exports = __webpack_public_path__ + "img/ms_img.04f5dba2.png";